import { render, staticRenderFns } from "./infoEmployee.vue?vue&type=template&id=3afecd64&"
import script from "./infoEmployee.vue?vue&type=script&lang=js&"
export * from "./infoEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports